import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, EmptyState, Loader } from "@/components/PageUI";
import { Trophy } from "lucide-react";

export default function Rankings() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/rankings").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows) return <Loader />;

  return (
    <div className="animate-fade-up">
      <PageHeader title="Team Rankings" subtitle="Standings from completed matches (3 pts win, 1 pt draw)." testid="rankings-header" />
      {rows.length === 0 ? (
        <EmptyState icon={Trophy} title="No completed matches" desc="Record match results to build the standings." testid="empty-rankings" />
      ) : (
        <div className="rounded-2xl border border-border bg-card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-accent/50 text-muted-foreground">
              <tr>{["#", "Team", "P", "W", "D", "L", "Pts"].map((h) => <th key={h} className="text-left px-4 py-3 font-semibold">{h}</th>)}</tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.team_id} className="border-t border-border" data-testid={`ranking-row-${r.team_id}`}>
                  <td className="px-4 py-3">
                    <span className={`inline-flex h-6 w-6 items-center justify-center rounded-full text-xs font-bold ${i === 0 ? "brand-gradient text-white" : "bg-accent"}`}>{i + 1}</span>
                  </td>
                  <td className="px-4 py-3 font-semibold">{r.name}</td>
                  <td className="px-4 py-3">{r.played}</td>
                  <td className="px-4 py-3 text-emerald-400">{r.wins}</td>
                  <td className="px-4 py-3">{r.draws}</td>
                  <td className="px-4 py-3 text-red-400">{r.losses}</td>
                  <td className="px-4 py-3 font-heading font-bold">{r.points}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
